import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_USER_UPDATE:
      return action.listsUser
    // return UpdateObjectHelpers(state, { listsUser: action.listsUser });
    default:
      return state
  }
}
// WOOT
// export default function (state = {}, action) {
//     switch (action.type) {
//         case actionTypes.USER_UPDATE:
//             return UpdateObjectHelpers(state, { userName: action.user })
//         default:
//             return state;
//     }
// }
